<script setup lang="ts">
import { cn } from "@client/lib/utils";
import { ToastTitle, type ToastTitleProps } from "reka-ui";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<ToastTitleProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ToastTitle v-bind="delegatedProps" :class="cn('tw:text-sm tw:font-semibold', props.class)">
		<slot />
	</ToastTitle>
</template>
